import { v4 as uuid } from 'uuid';

export default [
  {
    id: uuid(),
    createdAt: '27/03/2019',
    description: '1000 Request Per Mounth',
    amountM: '$9.00',
    amountY: '$50.00',
    type:'basic',
    priceM:9.00,
    priceY:50.00,
    title: 'Basic Account',
    details: [
      {
        dis:"Unlimited Calls",
        status: true,
      },
      {
        dis:"24/7 Call Support",
        status: true,
      },
      {
        dis:"Intigration with all Languages",
        status: true,
      },
      {
        dis:"Woocommerce Plugin",
        status: true,
      },
      {
        dis:"Search By street address",
        status: true,
      }
    ]
  },
  {
    id: uuid(),
    createdAt: '31/03/2019',
    description: '10,000 Request Per Month',
    amountM: '$19.00',
    amountY: '$99.00',
    type: 'standard',
    priceM: 19.00,
    priceY: 99.00,
    title: 'Standard Account',
    details: [
      {
        dis:"Unlimited Calls",
        status: true,
      },
      {
        dis:"24/7 Call Support",
        status: true,
      },
      {
        dis:"Intigration with all Languages",
        status: true,
      },
      {
        dis:"Woocommerce Plugin",
        status: true,
      },
      {
        dis:"Search By street address",
        status: true,
      }
    ]
  },
  {
    id: uuid(),
    createdAt: '03/04/2019',
    description: '100,000 requests Per Month',
    amountM: '$29.00',
    amountY: '$199.00',
    type:'premium',
    priceM:29.00,
    priceY: 199.00,
    title: 'Premium Account',
    details: [
      {
        dis:"Unlimited Calls",
        status: true,
      },
      {
        dis:"24/7 Call Support",
        status: true,
      },
      {
        dis:"Intigration with all Languages",
        status: true,
      },
      {
        dis:"Woocommerce Plugin",
        status: true,
      },
      {
        dis:"Search By street address",
        status: true,
      }
    ]
  },

];
